/* eslint-disable vue/no-use-v-if-with-v-for */
<template>
<div class="h-100" style="margin-inline-end: 30px !important;">
  <top-nav @changeComponent="changeComponent"
  :sortedOption="sortBy"
   v-on:sort-by-filter-updated="sortBinsTable"
   compoentType="BinsRootWorkspace" @changeDirectoryFromUrl="changeToDirectoryFromUrl" usedBy="Bins" :dirs="dirs" 
                                  :folderBrowseEnabled="enabledFolderBrowse"></top-nav>
  <div class="assets-view-wrapper" @click="closeContextMenu" >
    <template v-if="filteredBins && filteredBins.length>0">
    <ul class="thumbnail-view-ul folder-view-ul"  v-click-outside="unselectBin">
      <li class="folder-view-li" v-for="bin in filteredBins" :key="bin.bin_id"
       @click.exact="selectBin(bin)" @click.ctrl="selectBin(bin)"
        :class="{ activeBin: (isBinActive.includes(bin.bin_id)|| isBinSelected(bin.bin_id))}" @dblclick="showBinsDetails('bins-browse',bin)" @contextmenu="show($event, bin)" :ripple="false" :title="bin.bin_id" data-app>
          <!-- <div @contextmenu="show($event, bin)" :ripple="false" data-app> -->
          <div class="folder-view">
              <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-server" fill="#939393" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M1.333 2.667C1.333 1.194 4.318 0 8 0s6.667 1.194 6.667 2.667V4C14.665 5.474 11.68 6.667 8 6.667 4.318 6.667 1.333 5.473 1.333 4V2.667zm0 3.667v3C1.333 10.805 4.318 12 8 12c3.68 0 6.665-1.193 6.667-2.665V6.334c-.43.32-.931.58-1.458.79C11.81 7.684 9.967 8 8 8c-1.967 0-3.81-.317-5.21-.876a6.508 6.508 0 0 1-1.457-.79zm13.334 5.334c-.43.319-.931.578-1.458.789-1.4.56-3.242.876-5.209.876-1.967 0-3.81-.316-5.21-.876a6.51 6.51 0 0 1-1.457-.79v1.666C1.333 14.806 4.318 16 8 16s6.667-1.194 6.667-2.667v-1.665z"/>
            </svg>
          </div>
          <div class="bins-data">
              {{bin.bin_name}}
          </div>
          <!-- </div> -->
      </li>
    </ul>
    </template>
    <template v-else>
      <div style="font-size: 20px; margin-top: 8%; color: #686868;display: inline-flex;justify-content: center;width: 100%;">
          No Bins Found
      </div>
    </template>
    </div>
      <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y>
        <v-list>
          <v-list-item v-for="(item, index) in contextMenuOptions" :key="index" @click='handleRightClick(item)'>
            <v-list-item-title class="d-inline-flex"><div v-html="getSvgIconsForContextMenu(item.title)"></div><div style="padding-inline-start:7px;">{{ $t(item.title) }}</div></v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
  </div>
</template>


<script>
import TopNav from "../core/Topnavigation.vue";
import {mapGetters, mapMutations,mapActions } from "vuex";
import Utils from "../../components.utils.js";
import {NotifierConstants} from "../../components.constants.js";


export default {
  props:["selectedBinId","enabledFolderBrowse","enableMultiSelect","preSelectedBinIds"],
  components: {
    "top-nav": TopNav,
  },
  computed:{
    dirs(){
        return this.folderStructure
    },
    contextMenuOptions(){
      return this.items
    },
    filteredBins(){
      let filteredList = this.binsList
      if(this.filterByName && this.filterByName.trim().length > 0){
        filteredList = filteredList.filter(op=>op.bin_name.toLowerCase().startsWith(this.filterByName.trim().toLowerCase()))
      }
      return filteredList;
    },
    ...mapGetters("users",["getLoggedInUserPrivilege"])
  },
  methods: {
    filterBinsBy(binName){
      this.filterByName = binName
    },
    isBinSelected(binId){
      let indx = this.selectedBins.findIndex(e=>e._id==binId)
      if(indx >= 0){
        return true;
      }
      return false;
    },
    isEnabled(){
      return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, "Bins")
    },
    unselectBin(){
      this.isBinActive = [];
    },
    closeContextMenu(){
      this.showMenu = false
    },
    handleRightClick(info){
      if (info.title == "Open"){
        this.showBinsDetails('bins-browse', info.binInfo)
      }else{
        this.$toast.success(info.title)
      }
    },
    changeComponent(compName){
        this.unsetLocationHash()
        // Utils.unsetCookie('traverseHistory')
        this.$emit("changeSelectedMainComponent",compName)
    },
    showBinsDetails(comp,binsData={}){
        this.$emit("changeSelectedMainComponent",comp,binsData);
        if(comp == "catalogs-display"){
          Utils.updateCookieByKeyName("context","catalogs-display")
        }else if(comp == "bins-browse"){
          Utils.updateCookieByKeyName("context","bins")
        }
        this.$emit("clearSearchData");
    },
    changeToDirectoryFromUrl(binsData){
        let newStructure = []
        for (let dir of this.folderStructure) {
        if (dir._id === binsData.bin_id){
            break
        }else{
            newStructure.push(dir)
        }

        }
        this.folderStructure = newStructure;
    },
    getSvgIconsForContextMenu(menu){
        if (menu.includes("Add to Fav"))return Utils.getFavoriteSvg();
        if (menu.includes("Open"))return Utils.getOpenSvg();
    },
    show(event, bin) {
        this.items = []
        if (bin.bin_type == "asset" && this.isBinActive && this.isBinActive.length){
          this.items = [{'title':'Open', 'binInfo':bin}]
        }else if(bin.bin_type == "proxy" && this.isBinActive && this.isBinActive.length){
          this.items = [{'title':'Open', 'binInfo':bin}]
        }else{
          this.items = [{'title':'Open', 'binInfo':bin}]
        }
        event.preventDefault()
        this.showMenu = false
        this.x = event.clientX
        this.y = event.clientY
        this.$nextTick(() => {
          this.showMenu = true
        })
      },
    selectBin(bin){
      if(this.enabledFolderBrowse != undefined && !this.enabledFolderBrowse){
        return
      }
      let temp = bin
      temp["_id"] = bin.bin_id
      temp["id"] = bin.bin_id
      temp["parent_id_path"]="share_id:/"
      temp["path"] = `share://${bin.bin_id}`
      if(this.enableMultiSelect){
        let indx = this.selectedBins.findIndex(op=>op._id == bin.bin_id)
        if(indx >= 0){
          this.selectedBins = this.selectedBins.filter(op=>op._id != bin.bin_id)
          this.isBinActive = this.isBinActive.filter(op=>op!=bin.bin_id)
        }else{
          this.selectedBins.push(temp)
          this.isBinActive.push(bin.bin_id)
        }
        this.$emit("selectedRootBin",this.selectedBins)
      }else{
        this.selectedBins = [temp]
        this.isBinActive = [bin.bin_id]
        this.$emit("selectedRootBin",this.selectedBins)
      }
    },
    handleBinsNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
        let bin_info = notification.message
        if (notification.message_type == NotifierConstants.binRemovedNotification){
          if(bin_info.bin_type == 'asset'){
             this.binsList = this.binsList.filter((bin)=>bin.bin_id!=bin_info.bin_id);
          }
        }else if(notification.message_type == NotifierConstants.binCreatedNotification){
          if(bin_info.bin_type == 'asset'){
            this.binsList.push(bin_info);
          }
        }else{
          this.binsListFromServer(bin_info)
        }
      }
    },
    handleUrlChange(){
      let fileInfo = Utils.getHashLocationForBinBrowse()
      let catalogInfo = Utils.getHashLocationForCatalogBrowse()
      if (Object.keys(fileInfo).length != 0) {
        this.showBinsDetails('bins-browse', fileInfo)
      }else if (Object.keys(catalogInfo).length != 0) {
        this.showBinsDetails('catalogs-display')
      }
    },
    registerforWebsocketNotifications(){
        this.addWSEventListener({
          eventname:[NotifierConstants.binCreatedNotification, NotifierConstants.binModifiedNotification, NotifierConstants.binRemovedNotification],
          callback:this.handleBinsNotification,
          parent:"BinsDisplayComponent"})
    },
    unRegisterfromWebsocketNotifications(){
        this.removeWSEventListener({
          eventname:[NotifierConstants.binCreatedNotification, NotifierConstants.binModifiedNotification, NotifierConstants.binRemovedNotification],
          callback:this.handleBinsNotification,
          parent:"BinsDisplayComponent"})
    },
    binsListFromServer(){
      let payload = {}
      payload.params = {bin_type:"asset",status:"active"}
      if(this.sortBy && "label" in this.sortBy){
        switch(this.sortBy.label){
          case "Latest":
            payload.params["sort_by"] = "created_datetime"
            payload.params["sort_order"] = -1
            break;
          case "Oldest":
            payload.params["sort_by"] = "created_datetime"
            break;
          case "Name (A to Z)":
            payload.params["sort_by"] = "_id"
            break;
          case "Name (Z to A)":
            payload.params["sort_by"] = "_id"
            payload.params["sort_order"] = -1
            break;
          default:
            break;
        }
      }
      // window.addEventListener("hashchange", this.handleUrlChange, false);
      this.getAllBinsFromServer(payload).then((data)=>{
              this.binsList = data.bins;
      })
    },
    sortBinsTable(option){
         this.sortBy = option;
         localStorage.setItem("bins_sort_by_value", JSON.stringify(option));
         this.binsListFromServer();
    },
    loadBinsData(){
      this.binsListFromServer();
      this.registerforWebsocketNotifications();
      this.folderStructure.push({_id:0, file_name :this.selectedBinId})
    },
    handleRouteFilters(){
      if(Utils.getCookieValue("context") == "bins-display"){
        let query = Object.assign({},this.$route.query)
        if('keyword' in query){
          this.filterByName = query['keyword']
        }else{
          this.filterByName = ""
        }
      }
    },
    ...mapActions("files", ["getAllFilesFromServer"]),
    ...mapActions("bins",["getAllBinsFromServer"]),
    ...mapMutations("locations", ["unsetLocationHash"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"])
  },
  created() {
    // if(this.preSelectedBinIds){
    //     for(let op of this.preSelectedBinIds){
    //       let opPath = op
    //       opPath = opPath.replace("share://","")
    //       opPath = opPath.split("/")
    //       if(opPath && opPath.length == 1){
    //         let binId = opPath[0]
    //         let indx = this.selectedBins.findIndex(e=>e._id==binId)
    //         if(indx < 0){
    //           let temp = {}
    //           temp["_id"] = binId
    //           temp["id"] = binId
    //           temp["parent_id_path"]="share_id:/"
    //           temp["path"] = `share://${binId}`
    //           this.selectedBins.push(temp)
    //           this.isBinActive.push(binId)
    //         }
    //       }
    //     }
    //   }
   
    const savedSortBy = localStorage.getItem("bins_sort_by_value");
    if (savedSortBy) {
      try {
        this.sortBy = JSON.parse(savedSortBy);
      } catch (error) {
        console.error("Invalid bins_sort_by_value in localStorage", error);
      }
    }

    this.handleRouteFilters();
    this.loadBinsData()
    
  },
  mounted(){
    this.$emit("selectedSingleFile", {});
    this.$emit("selectedMultipleFiles", {});
  },
  beforeDestroy(){
    // window.removeEventListener("hashchange",()=>{})
    this.unRegisterfromWebsocketNotifications()
  },
  data() {
    return {
        binsList:{},
        folderStructure:[],
        showMenu: false,
        x: 0,
        y: 0,
        items: [],
        isBinActive:[],
        selectedBins:[],
        filterByName:"",
        sortBy:null,
    };
  },
  watch:{
    "$route" : function(newVal, oldVal){
      console.log("BinsDisplay.vue Roter", newVal.fullPath, oldVal.fullPath  , newVal.fullPath != oldVal.fullPath)
      if (newVal.fullPath != oldVal.fullPath){
        this.handleRouteFilters()
      }
    }
  }
};
</script>



<style lang="scss" scoped>
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $button-height:38px;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;
    $secondary-border-color:#767676;

.activeAsset,.activeMultipleAssets {
  border: 2px solid #037afb  !important;
  border-radius: 5px !important;
  .thumbnail-data{
    background: #1879e28c !important;
  } 
}

// .thumbnail-view-ul{
//   li:hover{
//     border: $border-color;
//     border-radius: 5px;
//   }
// }
.thumbnail-view-ul {
  list-style-type: none;
  display: inline-flex;
  flex-wrap: wrap;
  padding: 0px;
  margin-top: 0px;
  width: 100%;
  padding-inline-start: 20px;
  justify-content: start;
  overflow: auto;
  li {
    display: inline-block;
    margin-inline-end: 10px;
    width: 174px;
    padding-inline-start: 7px;
    margin-top: 5px;
    height: 124px;
    .thumbnail-view {
      height: 93px;
      width: 160px;
      border-radius: 7px;
      margin-top: 8px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 7px;
      }
    }
    .thumbnail-data {
      white-space: nowrap;
      width: 173px;
      overflow: hidden;
      text-overflow: ellipsis;
      position: relative;
      inset-inline-end: 4%;
    }
  }
}

.folder-view-li:hover{
  border: 1px solid $secondary-border-color !important;
}

.activeFolder {
  border: 1px solid $active-blue !important;
  color: $active-blue !important;
  .folder-view {
    svg {
      color: $active-blue !important;
    }
  }
}

.folder-view-ul{
  padding-top: 10px;
  margin-bottom: 10px;
.folder-view-li{
    display:inline-flex !important;
    height: 52px !important;
    border: $border-color;
    border-radius: 6px;
    .folder-view{
        font-size:30px;
    }
    .bins-data{
        margin-top: 15px;
        margin-inline-start: 7px;
        width: 118px;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align:start;
    }
}
}
/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.folder-view-ul{
  padding-top: 10px;
  margin-bottom: 10px;
.folder-view-li{
    display:inline-flex !important;
    height: 52px !important;
    border: $border-color;
    border-radius: 6px;
    .folder-view{
        font-size:30px;
    }
    .folder-data{
        margin-top: 15px;
        margin-inline-start: 7px;
        width: 118px;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align:start;
    }
}
}

.assets-view-wrapper{
    height:calc(100vh - 150px) !important;
    white-space: nowrap;
    overflow:auto;
    display: inline-block;
    width:100%;
}

.activeBin, .activeBin:hover{
  border:1px solid $active-blue !important;
  // color:$active-blue !important;
  .folder-view{
    svg{
      color:$active-blue !important;
    }
  }
}

::v-deep{
  .v-list{
  padding:0px !important;
}
.v-list-item{
  text-align: start;
  border: $secondary-border-color !important;
  min-height: 37px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
    .v-list-item__title{
          font-size: 14px !important;
          color:$text-color !important;
    }
  }
}

</style>
